import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useQueryClient } from 'react-query';

import { Wrap, Header } from '@components';

const TestPage = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    console.warn('mount');
    return () => {
      console.warn('unmount');
      queryClient.removeQueries();
    };
  }, []);
  return (
    <Wrap>
      <Header /> <Outlet />
    </Wrap>
  );
};

export default TestPage;
